"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var IconButton_1 = __importDefault(require("../../../IconButton"));
var props_1 = require("../../context/props");
var CloseButton = function () {
    var onClose = (0, props_1.usePropsContext)().onClose;
    return (react_1.default.createElement(IconButton_1.default, { onClick: onClose, kind: "close" }));
};
exports.default = CloseButton;
